import React, { useEffect, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Grid, Tooltip } from "@material-ui/core";
import { Link } from 'react-router-dom';
import { DatePickerInput } from 'rc-datepicker';
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import Moment from "moment";
import BiztranControls from "../../biztran_controls/BiztranControls";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import moment from "moment";

const todate = new Date();
// let fromDate = new Date().getFullYear() + "/04/01"
// const fromdate = new Date().setFullYear(new Date().getFullYear(), -10);
// const fromdate = new Date(new Date().setDate(new Date().getDate() - 300));
let fromDate = new Date("2024/04/01");
let Dfromdate = new Date("2024/04/01")

const SalesAnalysis = () => {

    const [Status, setStatus] = useState('');
    const [Customer, setCustomer] = useState('');
    const [Industry, setIndustry] = useState('');
    const [Count, setCount] = useState('');
    const [SalesExecutiveID, setSalesExecutiveID] = useState('');
    // const [SalesExecutiveID, setSalesExecutiveID] = useState('');
    const [FromDate, setFromDate] = useState(fromDate);
    const [defaultfromDate, setdefaultfromDate] = useState(Dfromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [ProductGroupIDcmb, setProductGroupIDcmb] = useState([]);
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [ComboSalesExecutive, setComboSalesExecutive] = useState([]);
    const [ProductIDcmb, setProductIDcmb] = useState([]);
    const [CountryIDcmb, setCountryIDcmb] = useState([]);
    const [StateIDcmb, setStateIDcmb] = useState([]);
    const [IndustryIDcmb, setIndustryIDcmb] = useState([]);
    const [ProductID, setProductID] = useState('');
    const [ProductGroupID, setProductGroupID] = useState('');
    const [CountryID, setCountryID] = useState('');
    const [IndustryID, setIndustryID] = useState('');
    const [AccountID, setAccountID] = useState('');
    const [AccountName, setAccountName] = useState('');
    const [AccName, setAccName] = useState('');
    const [StateID, setStateID] = useState('');
    const [responseAccount, fetchAccountData] = UseFetchData();
    const [AccountOptions, setAccountOptions] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [SearchMode, setSearchMode] = useState("SEARCH");

    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }
    const AccountData = () => {
        var bodyFormData = new FormData();
        fetchAccountData("QuotationAnalysis/ComboData", bodyFormData);
    }

    useEffect(() => {
        if (ComboDataResponse !== undefined) {
            if (ComboDataResponse["Productcmb"] !== undefined) {
                setProductIDcmb(ComboDataResponse["Productcmb"]);
            }
            if (ComboDataResponse["cmbProductGroup"] !== undefined) {
                setProductGroupIDcmb(ComboDataResponse["cmbProductGroup"]);

            }
            if (ComboDataResponse["cmbCountry"] !== undefined) {
                setCountryIDcmb(ComboDataResponse["cmbCountry"]);

            }
            if (ComboDataResponse["cmbState1"] !== undefined) {
                setStateIDcmb(ComboDataResponse["cmbState1"]);

            }
            if (ComboDataResponse["cmbIndustry"] !== undefined) {
                setIndustryIDcmb(ComboDataResponse["cmbIndustry"]);

            }
            if (ComboDataResponse["SalesExecutive"] !== undefined) {
                setComboSalesExecutive(ComboDataResponse["SalesExecutive"]);

            }

            //   if (ComboDataResponse["Productcmb"] !== undefined) {
            //     setProductIDcmb(ComboDataResponse["Productcmb"]);
            //   }
            //   PopulateData(SearchMode);

        }
    }, [ComboDataResponse]);

    const GetComboData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("ProductID", "");
        // bodyFormData.append("ProductCat1ID", "");
        // bodyFormData.append("ProductCat2ID", "");
        // bodyFormData.append("ProductCat3ID", "");
        fetchComboData("QuotationAnalysis/ComboData", bodyFormData);
    };


    const onACCChange = (event, newValue) => {
        // debugger;
        setAccountName(newValue);
        setAccountID(newValue.id);
    }

    useEffect(() => {
        // debugger;
        if (responseAccount['cmbAccount'] !== undefined && responseAccount['cmbAccount'].length > 0) {
            setAccountOptions(responseAccount['cmbAccount']);
        }
    }, [responseAccount['cmbAccount']]);

    const PopulateData = () => {
        // debugger;
        var SalesTeamList = "";
        var AccoName = "",
            AcName = null;
        // debugger;
        var bodyFormData = new FormData();
        if (AccountName !== undefined) {
            AccoName = AccountName.AccountName;
        }
        if (AccName !== "") {
            AcName = AccName;
        }
        var bodyFormData = new FormData();
        bodyFormData.append("AccountName", AccountName.List);
        bodyFormData.append("IndustryID", IndustryID);
        bodyFormData.append("SalesExecutiveID", sessionStorage.UID);
        bodyFormData.append("UserType", sessionStorage.UserType);
        bodyFormData.append("UserName", sessionStorage.UserName);
        bodyFormData.append("UserGroupID", sessionStorage.UserGroupID);
        bodyFormData.append("UserID", sessionStorage.UID);
        bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
        bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
        bodyFormData.append("Status", Status);
        // bodyFormData.append("SearchString", AccName);
        bodyFormData.append("StateID", StateID);
        bodyFormData.append("ProductGroupID", ProductGroupID);
        bodyFormData.append("ProductID", ProductID);
        bodyFormData.append("CountryID", CountryID);
        //bodyFormData.append("Description", Description);
        fetchData("QuotationAnalysis/ListQuotationAnalysis", bodyFormData);
    };

    useEffect(() => {
        const gridCols = [
            {
                field: "id",
                headerName: ".",
                renderCell: (params) => (<strong> <Link to={{ pathname: "/quotation/QuotationView", state: { QuotationID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
                // renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong>),
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 70,
            },
            {
                field: "QuotationNo",
                headerName: "QutNo",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 130,
            },
            {
                field: "QuotationDate",
                headerName: "Qut Dt",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
                valueFormatter: params =>
                    moment(params?.value).format("DD/MM/YYYY"),
            },
            {
                field: "ValidUpTo",
                headerName: "Validity Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
                valueFormatter: params =>
                    moment(params?.value).format("DD/MM/YYYY"),
            },

            {
                field: "AccountName",
                headerName: "Customer Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 210,
                renderCell: (params) => (
                    <Tooltip title={params.row.AccountName} >
                        <span className="table-cell-trucate">{params.row.AccountName}</span>
                    </Tooltip>
                ),
            },
            {
                field: "Country",
                headerName: "Country",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,

            },
            {
                field: "AccountGroup",
                headerName: "Account Group",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 190,
            },
            {
                field: "Industry",
                headerName: "Industry",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "QuotationStage",
                headerName: "Order Status",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "TotalAmount",
                headerName: "Quotation Amt",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 190,
            },
            {
                field: "SalesOrderNo",
                headerName: "Sales Order Number",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 240,
            },
            {
                field: "SalesOrderDate",
                headerName: "Sales Order Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
                valueFormatter: params => {
                    const value = params?.value;
                    // Check if the value is not null, undefined, or an empty string
                    return value ? moment(value).format("DD/MM/YYYY") : "";
                },
            },
            {
                field: "SOAmount",
                headerName: "Sales Order Value",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 240,
            },
            {
                field: "ProductGroup",
                headerName: "Product Group",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 240,
            },
            {
                field: "GeneratedBy",
                headerName: "Generated By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 240,
            },
            {
                field: "NoOfDays",
                headerName: "No Of Days",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 240,
            },
            {
                field: "Remarks",
                headerName: "Remarks",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "Activity1",
                headerName: "Activity 1",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "Activity1Date",
                headerName: "Activity1 Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
                valueFormatter: params => {
                    const value = params?.value;
                    // Check if the value is not null, undefined, or an empty string
                    return value ? moment(value).format("DD/MM/YYYY") : "";
                },
            },
            {
                field: "Activity2",
                headerName: "Activity 2",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "Activity2Date",
                headerName: "Activity2 Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
                valueFormatter: params => {
                    const value = params?.value;
                    // Check if the value is not null, undefined, or an empty string
                    return value ? moment(value).format("DD/MM/YYYY") : "";
                },
            },
            {
                field: "Activity3",
                headerName: "Activity 3",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "Activity3Date",
                headerName: "Activity3 Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
                valueFormatter: params => {
                    const value = params?.value;
                    // Check if the value is not null, undefined, or an empty string
                    return value ? moment(value).format("DD/MM/YYYY") : "";
                },
            },
            {
                field: "Activity4",
                headerName: "Activity 4",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "Activity4Date",
                headerName: "Activity4 Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
                valueFormatter: params => {
                    const value = params?.value;
                    // Check if the value is not null, undefined, or an empty string
                    return value ? moment(value).format("DD/MM/YYYY") : "";
                },
            },
            {
                field: "Activity5",
                headerName: "Activity 5",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "Activity5Date",
                headerName: "Activity5 Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
                valueFormatter: params => {
                    const value = params?.value;
                    // Check if the value is not null, undefined, or an empty string
                    return value ? moment(value).format("DD/MM/YYYY") : "";
                },
            },
        ];
        setColumns(gridCols);
        // debugger;
        setRows(response);
        setCount(response.length);
    }, [response]);

    useEffect(() => {
        GetComboData();
        PopulateData();
        AccountData();

    }, []);

    function CustomToolbar() {
        return (
            <GridToolbarContainer style={{ marginLeft: '93%' }}>
                <GridToolbarExport csvOptions={{
                    fields: ['QuotationNo', 'QuotationDate', 'ValidUpTo', 'AccountName', 'Country', 'AccountGroup', 'Industry', 'QuotationStage', 'TotalAmount', 'SalesOrderNo', 'SalesOrderDate', 'SOAmount', 'ProductGroup', 'GeneratedBy', 'NoOfDays', 'Remarks', 'Activity1','Activity1Date', 'Activity2','Activity2Date', 'Activity3', 'Activity3Date','Activity4','Activity4Date','Activity5','Activity5Date'],
                }} />
            </GridToolbarContainer>
        );
    }

    return <div >
        <Grid container direction="row" >
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <div style={{ width: "198px", marginLeft: 6 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setFromDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onFromClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultfromDate}
                    />
                </div>
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <div style={{ width: "198px", marginLeft: 7 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setToDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onToClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultToDate}
                    />
                </div>
            </Grid>
            <label style={{ fontWeight: 'bold', width: 30, marginTop: 30 }}>{Count}</label>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Button
                    text="Populate"
                    style={{ marginRight: 50, marginTop: 20, marginLeft: 10 }}
                    startIcon={<SearchIcon />}
                    onClick={() => {
                        PopulateData();
                    }}
                />
            </Grid>
            {/* <Grid xs={12} sm={3} md={3} lg={2} xl={2} style={{ marginTop: 14 }} >
                <BiztranControls.Autocomplete
                    label="Customer"
                    options={AccountOptions}
                    style={{ marginLeft: 7, marginTop: -7, width: "198px" }}
                    onChange={onACCChange}
                    value={AccName}>
                </BiztranControls.Autocomplete>
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} style={{ marginTop: 14 }} >
                <BiztranControls.Select
                    label="Industry"
                    id="Industry"
                    options={IndustryIDcmb}
                    onChange={(e) => setIndustryID(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} style={{ marginTop: 14 }} >
                <BiztranControls.Select
                    label="ProductName"
                    id="Product"
                    options={ProductIDcmb}
                    onChange={(e) => setProductID(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} style={{ marginTop: 14 }}>
                <BiztranControls.Select
                    label="ProductGroup"
                    id="ProductGroup"
                    options={ProductGroupIDcmb}
                    onChange={(e) => setProductGroupID(e.target.value)}
                />
            </Grid> */}
        </Grid>
        <Grid container direction="row" style={{ marginTop: 7 }} >
            {/* <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Input
                    label="Status"
                    id="Status"
                    onChange={(e) => setStatus(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Select
                    label="Country"
                    id="Country"
                    options={CountryIDcmb}
                    onChange={(e) => setCountryID(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Select
                    label="State"
                    id="State"
                    options={StateIDcmb}
                    onChange={(e) => setStateID(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Select
                    label="Sales Executive"
                    id="SalesExecutiveID"
                    options={ComboSalesExecutive}
                    onChange={(e) => setSalesExecutiveID(e.target.value)}
                />
            </Grid> */}
            {/* <label style={{ fontWeight: 'bold', width: 30, marginTop: 15, marginLeft: -10 }}>{Count}</label>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Button
                    text="Populate"
                    style={{ marginRight: 50 }}
                    startIcon={<SearchIcon />}
                    onClick={() => {
                        PopulateData();
                    }}
                />
            </Grid> */}
        </Grid>
        <BiztranControls.DataGrid
            headerHeight={34}
            rowHeight={25}
            rows={rows}
            columns={columns}
            checkboxSelection={false}
            // autoHeight={true}
            //Height="2610px"
            Height="400px"
            Width="100%"
            components={{ Toolbar: CustomToolbar, }}
        />
    </div>
};

export default SalesAnalysis;